<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { Icon, Button, TooltipTrigger, Tooltip, TooltipContent } from '@/ui'
import { cn } from '@/utils'

import { useSidebar } from './utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()

const { toggleSidebar } = useSidebar()
</script>

<template>
  <Tooltip :delay-duration="0">
    <TooltipTrigger>
      <Button
        data-sidebar="trigger"
        variant="ghost"
        size="icon"
        :class="cn('size-8', props.class)"
        @click="toggleSidebar"
      >
        <Icon name="Bars3BottomLeftIcon" class="size-5" lib="solid" />
        <span class="sr-only">Toggle Sidebar</span>
      </Button>
    </TooltipTrigger>
    <TooltipContent class="bg-primary text-primary-foreground text-xs whitespace-normal">
      Toggle Sidebar (Cmd/Ctrl + B)
    </TooltipContent>
  </Tooltip>
</template>
